import React from 'react'
import { Formik } from 'formik'

const Form = ({
  children,
  className,
  onSubmit,
  redirect,
  history,
  serializeErrors,
  ...props
}) => (
  <Formik
    {...props}
    onSubmit={(values, { setSubmitting, setErrors, setStatus }) => {
      Promise.resolve(onSubmit(values))
        .then(() => {
          redirect ? (window.location = redirect) : setSubmitting(false)
        })
        .catch(error => {
          setSubmitting(false)
          setErrors({ form: serializeErrors ? serializeErrors(error) : error })
        })
    }}
    render={({ handleSubmit }) => (
      <form onSubmit={handleSubmit} className={className}>
        {children}
      </form>
    )}
  />
)

Form.displayName = 'Form'

Form.defaultProps = {
  validateOnBlur: false,
  validateOnChange: false
}

export default Form
